import { STATUS_ID } from "../utils/enums";
import { apiFetch } from "./httpClient";

export async function getAllFlashProducts() {
  const URL = `/products`;
  const response = await apiFetch(URL, {
    method: "GET",
  });
  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "Could not fetch products.");
  }

  return data.filter((product) => product.estatusId === 1);
}

export async function searchProducts(body) {
  const URL = `/products/filter?title=${body}`;

  const response = await apiFetch(URL, {
    method: "GET",
  });

  const data = await response.json();

  if (!response.ok) {
    let errorMessage;
    if (data && data.error && data.error.message) {
      errorMessage = data.error.message;
    }
    throw new Error(errorMessage);
  }
  return (
    data?.data?.content?.filter(
      (product) => product.estatusId === STATUS_ID.ACTIVE,
    ) ?? []
  );
}

export async function getProductDetail({ categoryId, productId }) {
  const URL = `/products/v1/categoryVariant/categoryId/${categoryId}/productId/${productId}`;
  const response = await apiFetch(URL, {
    method: "GET",
  });
  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "Could not fetch product detail.");
  }

  return data;
}
